module.exports = __webpack_public_path__ + "media/images/speaker_events_database-77eed53a.svg";